import React from 'react';

const Header = () => (
  <section id="header">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <a href="#/"><img src="assets/Qlik-Logo_TAG_Right_WHITE.png" className="logo" alt="logo" width="300px" /></a>
        </div>
      </div>
      <div className="row">
        <div className="col-md-9">
          <h1>Financial Indicators</h1>
          <p>The world of finance never sits still. These key statistics provide a glimpse into the direction of the overall economy, based on key economic and financial indicators.The charts are available in static and embeddable formats.</p>
          <p> Qlik Data Market is a live source of trusted, affordable, ready-to-use data from external sources, whenever you need it. All of the charts in this app are powered by Data Market data.</p>
        </div>
      </div>
    </div>
  </section>
);

export default Header;



// WEBPACK FOOTER //
// ./src/pages/Header.jsx